import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import Input from '../../input'
import ButtonContained from '../../button';
import DropdownComp from '../../dropdown';
import { AddSupportSchema } from '../../../validation/ValidationSchema';
import { getMerchants }  from '../../../helpers/listsApi';
import { api } from '../../../api';
import { toast } from "react-toastify";
import { useNavigate} from 'react-router-dom';
import { useSelector } from "react-redux";
import usePasswordToggle  from '../../hooks/usePasswordToggle';

const AddSupport = () => {
    const token = useSelector((state) => state.auth.token);
    // eslint-disable-next-line
    const { userType: role } = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
   
    const [merchants, setMerchants] = useState([]);
    const [PwdInputType, ToggleIcon] = usePasswordToggle();


    useEffect(() => {
        getMerchants(false,token).then(dt => {
            setMerchants(dt)
        })
    }, [token])
    return (

        <Formik
            validationSchema={AddSupportSchema}
            initialValues={{
                usersUserName: '',
                usersUserType: '4',
                usersPhone: '',
                usersEmail: '',
                usersName: '',
                usersPassword: '',
                // merchants: '',
                confpassword: '',
                usersMerchentIds: null,
                is2faEnabled: true
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                const formBody = {
                    ...values,
                    usersMerchentIds: values.usersMerchentIds.map(pr => pr.value).toString()
                }
                api.users.addCustomer(formBody,token).then(result => {
                    if (result.success === false) {
                        toast.error(result.message);
                        resetForm({});
                    } else {
                        toast.success(result.message);
                        navigate('/customer-support')
                    }
                    setSubmitting(false)

                }).catch(err => {
                    console.log(err)
                });
            }}
        >
            {({
                handleSubmit,
                handleChange,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue
            }) => {

                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">ADD SUPPORT</h1>
                                    </div>
                                    <div className="card card-table">
                                        {/* <div className="card-header card-header-title">Customer Support Details</div> */}
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports agents">
                                                <Form noValidate validated={!isValid} onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersUserName"
                                                                name="usersUserName"
                                                                placeholder="User Name"
                                                                type="text"
                                                                label="User Name"
                                                                value={values.usersUserName}
                                                                onChange={handleChange}
                                                                error={touched.usersUserName && errors.usersUserName}
                                                                errorText={errors.usersUserName}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersPhone"
                                                                name="usersPhone"
                                                                placeholder="Phone Number"
                                                                type="number"
                                                                label="Phone"
                                                                value={values.usersPhone}
                                                                onChange={handleChange}
                                                                error={touched.usersPhone && errors.usersPhone}
                                                                errorText={errors.usersPhone}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersEmail"
                                                                name="usersEmail"
                                                                placeholder="Email Id"
                                                                label="Email"
                                                                value={values.usersEmail}
                                                                onChange={handleChange}
                                                                error={touched.usersEmail && errors.usersEmail}
                                                                errorText={errors.usersEmail}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersName"
                                                                name="usersName"
                                                                placeholder="Support Name"
                                                                label="Support Name"
                                                                value={values.usersName}
                                                                onChange={handleChange}
                                                                error={touched.usersName && errors.usersName}
                                                                errorText={errors.usersName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="usersPassword"
                                                                name="usersPassword"
                                                                placeholder="Password"
                                                                type={PwdInputType}
                                                                autoComplete="usersPassword"
                                                                onPaste={true}
                                                                label="Set Password"
                                                                value={values.usersPassword}
                                                                onChange={handleChange}
                                                                error={touched.usersPassword && errors.usersPassword}
                                                                errorText={errors.usersPassword}
                                                                disabled={isSubmitting} 
                                                                isToggle={ values.usersPassword ? true: false }
                                                                toggleIcon={ ToggleIcon }/>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="confpassword"
                                                                name="confpassword"
                                                                placeholder="Confirm Password"
                                                                type="password"
                                                                autoComplete="confpassword"
                                                                onPaste={true}
                                                                label="Confirm Password"
                                                                value={values.confpassword}
                                                                onChange={handleChange}
                                                                error={touched.confpassword && errors.confpassword}
                                                                errorText={errors.confpassword}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                    <div className="form-row">

                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                isMulti
                                                                id="merchants"
                                                                name="usersMerchentIds"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("usersMerchentIds", selectedValue)
                                                                }}
                                                                value={values.usersMerchentIds}
                                                                options={merchants}
                                                                label="Merchants"
                                                                placeholder="Please select"
                                                                error={touched.usersMerchentIds && errors.usersMerchentIds}
                                                                errorText={errors.usersMerchentIds}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                           <div className="form-group col-md-4">
                                                            <label htmlFor="is2faEnabled" className="d-block mb-2">
                                                                Enable 2FA
                                                            </label>
                                                            <div className="custom-control custom-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="is2faEnabled"
                                                                    name="is2faEnabled"
                                                                    checked={values.is2faEnabled}
                                                                    onChange={(e) => setFieldValue("is2faEnabled", e.target.checked)}
                                                                    disabled={isSubmitting}
                                                                />
                                                                <label className="custom-control-label" htmlFor="is2faEnabled">
                                                                    {values.is2faEnabled ? "Enabled" : "Disabled"}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <ButtonContained buttonName="Save"
                                                        disabled={isSubmitting} />
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Formik>
    )
}

export default AddSupport;